import { Link } from 'react-router-dom';
import { Search, Wrench, MapPin, Phone, ArrowRight } from 'lucide-react';
import SEO from '@/components/SEO';

export default function NotFoundPage() {
  return (
    <>
      <SEO
        title="Page Not Found"
        description="The page you are looking for has moved or no longer exists. Book a projector repair, browse brands we service, or find your local collection area."
        canonical="https://projectorrepairlondon.co.uk/404"
        noindex
      />
      <section className="bg-[#0057B7] pt-32 pb-16 md:pt-40 md:pb-24">
        <div className="container-custom text-center">
          <p className="font-heading text-7xl md:text-8xl font-extrabold text-[#FFDD00]">404</p>
          <h1 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-white">
            This page has moved or no longer exists
          </h1>
          <p className="mt-4 text-white/80 max-w-xl mx-auto leading-relaxed">
            We recently rebuilt our website. If you followed an old link or bookmark,
            one of the options below will get you back on track.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Link to="/repair-enquiry" className="group rounded-2xl border border-[#0057B7]/15 bg-[#E8F0FE] p-6 hover:border-[#0057B7] transition-colors">
              <Wrench className="w-8 h-8 text-[#0057B7]" />
              <h2 className="mt-3 font-heading text-lg font-bold text-[#003D80]">Book a Repair</h2>
              <p className="mt-1 text-sm text-[#003D80]/80">Free collection, expert diagnostics, 90-day warranty.</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-[#0057B7] group-hover:gap-2 transition-all">Start <ArrowRight className="w-4 h-4" /></span>
            </Link>
            <Link to="/" className="group rounded-2xl border border-[#0057B7]/15 bg-[#E8F0FE] p-6 hover:border-[#0057B7] transition-colors">
              <Search className="w-8 h-8 text-[#0057B7]" />
              <h2 className="mt-3 font-heading text-lg font-bold text-[#003D80]">Repair Services</h2>
              <p className="mt-1 text-sm text-[#003D80]/80">White dots, overheating, discolouration, lamp & laser replacement.</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-[#0057B7] group-hover:gap-2 transition-all">View <ArrowRight className="w-4 h-4" /></span>
            </Link>
            <Link to="/locations" className="group rounded-2xl border border-[#0057B7]/15 bg-[#E8F0FE] p-6 hover:border-[#0057B7] transition-colors">
              <MapPin className="w-8 h-8 text-[#0057B7]" />
              <h2 className="mt-3 font-heading text-lg font-bold text-[#003D80]">Service Areas</h2>
              <p className="mt-1 text-sm text-[#003D80]/80">London & South East England collection coverage.</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-[#0057B7] group-hover:gap-2 transition-all">Browse <ArrowRight className="w-4 h-4" /></span>
            </Link>
            <a href="tel:03330064326" className="group rounded-2xl border border-[#0057B7]/15 bg-[#E8F0FE] p-6 hover:border-[#0057B7] transition-colors">
              <Phone className="w-8 h-8 text-[#0057B7]" />
              <h2 className="mt-3 font-heading text-lg font-bold text-[#003D80]">Call Us</h2>
              <p className="mt-1 text-sm text-[#003D80]/80">0333 006 4326 — Mon–Fri 9:00–17:00.</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-[#0057B7] group-hover:gap-2 transition-all">Call <ArrowRight className="w-4 h-4" /></span>
            </a>
          </div>

          <div className="mt-12 rounded-2xl border border-[#0057B7]/15 p-6">
            <h2 className="font-heading text-lg font-bold text-[#003D80]">Popular pages</h2>
            <ul className="mt-3 grid grid-cols-2 md:grid-cols-4 gap-2 text-sm">
              <li><Link className="text-[#0057B7] hover:underline" to="/brands/epson">Epson Repair</Link></li>
              <li><Link className="text-[#0057B7] hover:underline" to="/brands/optoma">Optoma Repair</Link></li>
              <li><Link className="text-[#0057B7] hover:underline" to="/brands/sony">Sony Repair</Link></li>
              <li><Link className="text-[#0057B7] hover:underline" to="/brands/panasonic">Panasonic Repair</Link></li>
              <li><Link className="text-[#0057B7] hover:underline" to="/services/white-dots-dmd">White Dots Repair</Link></li>
              <li><Link className="text-[#0057B7] hover:underline" to="/services/overheating-power">Overheating Repair</Link></li>
              <li><Link className="text-[#0057B7] hover:underline" to="/extended-warranty">Extended Warranty</Link></li>
              <li><Link className="text-[#0057B7] hover:underline" to="/about">About Us</Link></li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
